import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from 'utils/colors';
import { Table, Icon, Flag } from 'semantic-ui-react';
import { isQuoteMedia } from 'utils/helpers';
import { translation as translationTools } from '../../Translation/tools';

class TradeTable extends Component {
  calc_buys = (trades) =>
    trades.filter((trade) => trade.action_amount * trade.price > 0).length;

  calc_sells = (trades) =>
    trades.filter((trade) => trade.action_amount * trade.price < 0).length;

  calc_cash = (trades) =>
    trades.reduce(
      (total, trade) =>
        total + Number((trade.action_amount * trade.price).toFixed(2)),
      0
    );

  renderTable(trades) {
    const { french, partnerName, reallocate, exchangeRate } = this.props;
    const { targetTypePorts, selectedAccount, selectedTargetAcc } = reallocate;
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    const currencyAcc = selectedAccount.length
      ? selectedAccount.some((account) => account.currency === 'CAD')
        ? 'CAD'
        : 'USD'
      : 'CAD';

    const currencyTarget = selectedTargetAcc.length
      ? selectedTargetAcc.some((account) => account.currency === 'CAD')
        ? 'CAD'
        : 'USD'
      : 'CAD';
    const isUSD = targetTypePorts
      ? currencyAcc === 'USD'
      : currencyAcc === 'USD' && currencyTarget === 'USD';
    const divisor = isUSD ? exchangeRate : 1;
    // const divisor = 1;
    return (
      <div style={{ width: '100%' }}>
        <Table basic textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                {translationTools[language][translateEnding].TABLE_ASSET}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {
                  translationTools[language][translateEnding]
                    .TABLE_CURRENT_QUANTITY
                }
              </Table.HeaderCell>
              <Table.HeaderCell>
                {
                  translationTools[language][translateEnding]
                    .TABLE_TARGET_QUANTITY
                }
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translationTools[language][translateEnding].TABLE_ACTION}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {
                  translationTools[language][translateEnding]
                    .TABLE_TRADE_QUANTITY
                }
              </Table.HeaderCell>
              <Table.HeaderCell>
                {
                  translationTools[language][translateEnding]
                    .TABLE_ESTIMATED_VALUE
                }
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {trades.map((trade) => (
              <Table.Row>
                {trade.action_amount > 0 ? (
                  <Icon
                    name="plus square"
                    style={{
                      position: 'absolute',
                      display: 'block',
                      fontSize: '15px',
                      color: colors.darkBlue,
                      marginLeft: '-10px',
                      marginTop: '20px',
                      zIndex: '100',
                      background: 'white',
                    }}
                  />
                ) : trade.action_amount < 0 ? (
                  <Icon
                    name="minus square"
                    style={{
                      position: 'absolute',
                      display: 'block',
                      fontSize: '15px',
                      color: colors.red,
                      marginLeft: '-10px',
                      marginTop: '20px',
                      zIndex: '100',
                      background: 'white',
                    }}
                  />
                ) : (
                  <div />
                )}

                <Table.Cell width={5}>
                  {trade.ticker}
                  <SecurityName>{trade.name || 'N/A'}</SecurityName>
                </Table.Cell>
                <Table.Cell>
                  {trade.current_qty.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                  })}
                </Table.Cell>
                <Table.Cell>
                  {trade.target_qty.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                  })}
                </Table.Cell>
                <Table.Cell>
                  {trade.action_amount > 0 ? (
                    <Text buy>
                      {translationTools[language][translateEnding].TABLE_BUY}
                    </Text>
                  ) : trade.action_amount < 0 ? (
                    <Text>
                      {translationTools[language][translateEnding].TABLE_SELL}
                    </Text>
                  ) : (
                    <div>-</div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <div
                    style={{
                      color:
                        trade.action_amount * trade.price < 0
                          ? colors.red
                          : trade.action_amount * trade.price > 0
                          ? colors.darkBlue
                          : 'black',
                    }}
                  >
                    {Math.abs(trade.action_amount).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <div
                    style={{
                      color:
                        trade.action_amount * trade.price < 0
                          ? colors.red
                          : trade.action_amount * trade.price > 0
                          ? colors.darkBlue
                          : 'black',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {`$${(
                      Math.abs(trade.action_amount * trade.price) / divisor
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                    <Flag
                      style={{ marginLeft: '10px' }}
                      name={isUSD ? 'us' : 'ca'}
                      // name="ca"
                    />
                  </div>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  render() {
    const { trades, french, partnerName, reallocate, exchangeRate } =
      this.props;
    const { commission, targetTypePorts, selectedAccount, selectedTargetAcc } =
      reallocate;
    const actualTrades = trades.slice(0, -1);
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    const buys = this.calc_buys(actualTrades);
    const sells = this.calc_sells(actualTrades);
    // const cash =
    //   currency === 'USD'
    //     ? this.calc_cash(trades) / exchange
    //     : this.calc_cash(trades);
    const currencyAcc = selectedAccount.length
      ? selectedAccount.some((account) => account.currency === 'CAD')
        ? 'CAD'
        : 'USD'
      : 'CAD';

    const currencyTarget = selectedTargetAcc.length
      ? selectedTargetAcc.some((account) => account.currency === 'CAD')
        ? 'CAD'
        : 'USD'
      : 'CAD';
    const isUSD = targetTypePorts
      ? currencyAcc === 'USD'
      : currencyAcc === 'USD' && currencyTarget === 'USD';

    const commissionCurrency = isUSD
      ? Number(commission) * exchangeRate
      : Number(commission);

    const commissionCost = (buys + sells) * commissionCurrency;

    const accountCash = Number(
      selectedAccount.reduce(
        (sum, account) =>
          account.currency === 'USD'
            ? sum + account.cash * exchangeRate
            : sum + account.cash,
        0
      )
    );

    const cash = targetTypePorts
      ? trades[trades.length - 1]
      : this.calc_cash(actualTrades) +
        commissionCost +
        trades[trades.length - 1] -
        accountCash;

    return (
      <div style={{ width: '80%' }}>
        <div>
          <Summary>
            {translationTools[language][translateEnding].TABLE_HEADER_SUMMARY}
            <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
              <Icon
                name="plus square"
                style={{
                  fontSize: '15px',
                  verticalAlign: 'initial',
                  color: colors.darkBlue,
                }}
              />
              {translationTools[language][translateEnding].TABLE_HEADER_BUYS}
              <b>{buys}</b>
            </div>
            <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
              <Icon
                name="minus square"
                style={{
                  fontSize: '15px',
                  verticalAlign: 'initial',
                  color: colors.red,
                }}
              />
              {translationTools[language][translateEnding].TABLE_HEADER_SELLS}
              <b>{sells}</b>
            </div>
            <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
              <Icon
                name="dollar sign"
                style={{
                  fontSize: '15px',
                  verticalAlign: 'initial',
                  color: 'green',
                }}
              />
              {cash >= 0
                ? translationTools[language][translateEnding]
                    .TABLE_HEADER_CASH_REQUIRED
                : translationTools[language][translateEnding]
                    .TABLE_HEADER_CASH_REMAINING}
              <b>
                {`$${Math.abs(
                  isUSD ? cash / exchangeRate : cash
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
              </b>
              <Flag
                style={{ marginLeft: '10px' }}
                name={isUSD ? 'us' : 'ca'}
                // name="ca"
              />
            </div>
          </Summary>
        </div>
        {this.renderTable(actualTrades)}
      </div>
    );
  }
}

TradeTable.propTypes = {
  trades: PropTypes.array,
  // exchange: PropTypes.number.isRequired,
  // currency: PropTypes.string.isRequired,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
  reallocate: PropTypes.object,
  exchangeRate: PropTypes.number,
};

TradeTable.defaultProps = {
  trades: [],
  french: false,
  partnerName: '',
  reallocate: {},
  exchangeRate: 1,
};

export default connect((state) => ({
  trades: state.ReallocateAccount.tableData,
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
  reallocate: state.ReallocateAccount,
  exchangeRate: Number(state.Storage['pwpa-exchange-rate']),
}))(TradeTable);

const Summary = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.lightGrey};
  border-top: 1px solid ${colors.grey};
  border-bottom: 1px solid ${colors.grey};
  padding: 0.5rem;
  margin-top: 1rem;
  text-align: left;
  justify-content: center;
`;

const SecurityName = styled.div`
  font-size: 0.9rem;
  line-height: 1rem;
  color: ${(props) =>
    props.negative ? 'rgba(159,58,56, 0.6)' : 'rgba(0,0,0,0.5)'};
`;

const Text = styled.div`
  color: ${(props) => (props.buy ? colors.darkBlue : colors.red)};
`;
